it("should ignore require.config", function() {
	require.config({
	
	});
	requirejs.config({
	
	});
});
it("should have a require.version", function() {
	require.version.should.be.type("string");
});



/*****************
 ** WEBPACK FOOTER
 ** ./parsing/requirejs/index.js
 ** module id = 0
 ** module chunks = 0
 **/